import React, { Component } from 'react';
import { Icon, Table } from 'antd';

import * as channelController from '../../../../../../services/api/channel';
import AdLinkFormModal from './components/AdLinkFormModal/AdLinkFormModal';
import './AdLinkManagementPane.scss';

const PUBLIC_URL = process.env.PUBLIC_URL;

export default class AdLinkManagementPane extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            selectedRowKeys: [],
            modalVisible: false,
            selectedAdLinkId: undefined
        }
    }

    fetchData() {
        const { channelId } = this.props;

        channelController.getChannelAdLinks(channelId)
            .then((res) => res.json())
            .then((json) => this.setState({ dataSource: json }))
    }

    handleRemove() {
        const { channelId } = this.props;
        const { selectedRowKeys } = this.state;

        this.setState({ isLoading: true });

        channelController.deleteChannelAdLinks(channelId, selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    render() {
        const { channelId } = this.props;
        const { dataSource, selectedRowKeys, modalVisible, selectedAdLinkId } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;

        const columns = [{
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (text, record) => <a href={`${PUBLIC_URL}/enquiry?code=${text}`}>{text}</a>
        }, {
            title: 'Enquiry Type',
            dataIndex: 'enquiry_type',
            key: 'enquiry_type',
        }, {
            title: 'Programme',
            dataIndex: 'programme',
            key: 'programme',
            render: (text, record) => text ? text.name : '--'
        }, {
            title: 'Clicked',
            dataIndex: 'clicked',
            key: 'clicked',
            align: 'center'
        }, {
            title: 'Submitted',
            dataIndex: 'submitted',
            key: 'submitted',
            align: 'center'
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => this.setState({ modalVisible: true, selectedAdLinkId: record.id })} />)
        }];

        return (
            <div className="AdLinkManagementPane">
	            <div className="DataList">
	                <div className="table-btn-gp">
	                    <div className="table-btn-gp-left">
	                        <button onClick={(e) => this.setState({ modalVisible: true, selectedAdLinkId: undefined })}>
	                            <Icon type="plus"/>
	                            Create
	                        </button>
	                    </div>
	                    <div className="table-btn-gp-right">
	                        <button disabled={!isRowSelected} onClick={(e) => this.handleRemove()}>
	                            <Icon type="minus"/>
	                            Remove
	                        </button>
	                    </div>
	                </div>
	                <Table
	                    rowKey="id"
	                    columns={columns}
	                    dataSource={dataSource}
	                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}}
	                />
	            </div>
				<AdLinkFormModal
					visible={modalVisible}
					channelId={channelId}
					adLinkId={selectedAdLinkId}
					onCancel={(e) => this.setState({ modalVisible: false })}
					onCreateUpdate={(e) => {
						this.setState({ modalVisible: false });
						this.fetchData();
					}}
				/>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ChannelManagementPage/scenes/AdLinkManagementPane/AdLinkManagementPane.js